import React from "react";
import styled from "styled-components";
import Chip from "@material-ui/core/Chip";
import Wrapper from "../atoms/Wrapper";
import Link from "../atoms/Link";

const OuterWrapper = styled(Wrapper)`
  ${(props) =>
    props.small
      ? "padding: 0.1rem 0.5rem 0 0;"
      : "padding: 0.5rem 0.6rem 0.5rem 0;"}
`;

const SelectedVTuberListItem = (props) => {
  if (props.disable_link) {
    return (
      <OuterWrapper key={props.item.id}>
        <Chip
          variant="outlined"
          color="primary"
          onClick={(e) => {}}
          label={props.item.name}
          onDelete={props.handle_remove}
        />
      </OuterWrapper>
    );
  }

  return (
    <OuterWrapper key={props.item.id} small={props.small}>
      <Chip
        variant="outlined"
        size={props.small ? "small" : "medium"}
        color="primary"
        onClick={(e) => {}}
        component={Link}
        to={`/vtubers/${props.item.id}`}
        label={props.item.name}
        onDelete={props.handle_remove}
      />
    </OuterWrapper>
  );
};

export default SelectedVTuberListItem;
